module.exports = __webpack_public_path__ + "img/1.482d1255.jpg";